'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _appBasePath = require('../constants/appBasePath');

var _appBasePath2 = _interopRequireDefault(_appBasePath);

var _MobileUA = require('PatternValidationJS/patterns/MobileUA');

var _MobileUA2 = _interopRequireDefault(_MobileUA);

var _AndroidUA = require('PatternValidationJS/patterns/AndroidUA');

var _AndroidUA2 = _interopRequireDefault(_AndroidUA);

var _IosUA = require('PatternValidationJS/patterns/IosUA');

var _IosUA2 = _interopRequireDefault(_IosUA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USER_AGENT = navigator.userAgent;

// These are saved in the container and overwritten by each signup app.
var SETTINGS = (0, _immutable.Map)({
  // This should be overridden
  appName: 'core',

  // Used like: app.hubspot.com/${appBasePath}/some-route
  appBasePath: _appBasePath2.default,

  // Used when building routes
  baseHistoryPath: '',

  // used to send product name on 53 form submission after setup
  setupProductName: '',

  // Boosts the main container to a wider size
  expandedWidth: false,

  // REQUIRED
  // Function that is fired after a user is done with last step.
  onComplete: null,

  // When the app loads, we'll try to figure out what product the user
  // signed up for based on route and/or utms.
  signupProduct: null,

  // Passed from ?intent= query param, this is the key that explains the intent
  // of the signup, e.g for sales, academy, marketing, some point solution, etc.
  // Can be resolved to a URL using `getProductIntentLink`
  intentKey: null,

  // Can detect this at anytime.
  isMobile: _MobileUA2.default.test(USER_AGENT),
  isAndroid: _AndroidUA2.default.test(USER_AGENT),
  isIos: _IosUA2.default.test(USER_AGENT),

  // Number of steps of the registration form
  totalSteps: null
});

var AppConfigContainer = {
  has: function has(key) {
    return SETTINGS.has(key);
  },
  get: function get(key) {
    if (key) {
      return SETTINGS.get(key);
    }
    return SETTINGS;
  },
  set: function set(settings) {
    SETTINGS = SETTINGS.merge(settings);
  }
};

exports.default = AppConfigContainer;
module.exports = exports['default'];